import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { selectCredentialsSelected } from 'store/Credentials/selectors';
import {
  Wrapper, Icon, Title
} from './styled';

const BulkTitle = () => {
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const selectedCredentialsCount = credentialsSelected.length;

  const getTitle = () => {
    if (selectedCredentialsCount > 1) return 'vulns.edit.bulkTitle';
    else return 'vulns.edit.title';
  };

  const title = getTitle();

  return (
    <Wrapper isBulk={ selectedCredentialsCount > 1 }>
      <Icon />
      <Title>
        <FormattedMessage id={ title } />
      </Title>
    </Wrapper>
  );
};

export default BulkTitle;
